import { render } from "./Creditors.vue?vue&type=template&id=58c39ba0"
import script from "./Creditors.vue?vue&type=script&lang=js"
export * from "./Creditors.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__